import { render, staticRenderFns } from "./asistenciaAdministrador.vue?vue&type=template&id=34066fab&"
import script from "./asistenciaAdministrador.vue?vue&type=script&lang=js&"
export * from "./asistenciaAdministrador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports